import { DetailsBooking, ListBooking } from '../types';
import { SURVEYMONKEY_POST_STAY_SURVEY_URL } from '../config';

export const getBookingDetailsPageLink = (bookingId: string) => `/bookings/${bookingId}`;

export const getBookingCancellationQuotePageLink = (bookingId: string, stateSuffix = '') =>
  `/bookings/${bookingId}/cancellation-quote${stateSuffix}`;

export const getChangeDatesRequestPageLink = (bookingId: string, stateSuffix = '') =>
  `/bookings/${bookingId}/change-date-request${stateSuffix}`;

export const getChangeDatesPageLink = (bookingId: string, stateSuffix = '') => `/bookings/${bookingId}/change-date${stateSuffix}`;

export const getBookingListPageLink = () => '/bookings';

export const getUpdatePaymentMethodPageLink = (bookingId: string, stateSuffix = '') =>
  `/bookings/${bookingId}/update-payment-method${stateSuffix}`;

export const getChangeYourBookingLink = (booking: DetailsBooking) => {
  switch (true) {
    case booking.flags.isDateAmendableInApp:
      return getChangeDatesPageLink(booking.id);
    case booking.flags.isChangeDatesRequestEnabled:
      return getChangeDatesRequestPageLink(booking.id);
    default:
      return null;
  }
};

export const getSurveyLink = (booking: DetailsBooking | ListBooking) => {
  // Add custom variables: [ property_id, property_name, booking_ref, check_in, check_out ]
  // E.G: 'https://www.surveymonkey.com/r/MYXSJHB?property_id=1234&property_name=Hotel-A&booking_ref=QH123&check_in=01-01-2020&check_out=03-01-2020&survey_from=self-service'
  const surveyFrom = 'survey_from=self-service';
  const customVariables = `property_id=${booking.reservation.property.id}&property_name=${booking.reservation.property.name}&booking_ref=${booking.reference}&check_in=${booking.reservation.checkIn}&check_out=${booking.reservation.checkOut}&${surveyFrom}`;
  return `${SURVEYMONKEY_POST_STAY_SURVEY_URL}?${customVariables}`;
};
